import React from 'react'
import "./RecommendedVideo.css"
import VideoCard from "./VideoCard"

function Recommendedvideo() {
    return (
        <div className="recommended__video">
             <h2>Recommended</h2>
             <div className="recommendedVideo__Videos">
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJzxxCAjbTp4REiYb2YSOeIODVGlEBF6ngglse3k=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/kJQP7kiw5Fk/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJxYKvV8ivJXbjXGr-yTsZkStrHlWQ7aVmIFD0G69Q=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/7wtfhZwyrcc/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJzxxCAjbTp4REiYb2YSOeIODVGlEBF6ngglse3k=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/kJQP7kiw5Fk/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJxYKvV8ivJXbjXGr-yTsZkStrHlWQ7aVmIFD0G69Q=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/7wtfhZwyrcc/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJzxxCAjbTp4REiYb2YSOeIODVGlEBF6ngglse3k=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/kJQP7kiw5Fk/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJxYKvV8ivJXbjXGr-yTsZkStrHlWQ7aVmIFD0G69Q=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/7wtfhZwyrcc/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJzxxCAjbTp4REiYb2YSOeIODVGlEBF6ngglse3k=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/kJQP7kiw5Fk/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJxYKvV8ivJXbjXGr-yTsZkStrHlWQ7aVmIFD0G69Q=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/7wtfhZwyrcc/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJzxxCAjbTp4REiYb2YSOeIODVGlEBF6ngglse3k=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/kJQP7kiw5Fk/hqdefault.jpg"
                 />
                 <VideoCard 
                    title="Luis Fonsi - Despacito ft. Daddy Yankee"
                    views="6.9B views"
                    timestamp="3 years ago"
                    channelImage="https://yt3.ggpht.com/a/AATXAJxYKvV8ivJXbjXGr-yTsZkStrHlWQ7aVmIFD0G69Q=s48-c-k-c0xffffffff-no-nd-rj"
                    channel="Luis Fonsi"
                    image="https://i.ytimg.com/vi/7wtfhZwyrcc/hqdefault.jpg"
                 />
             </div>
        </div>
    )
}

export default Recommendedvideo
